import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageEditScreenComponent } from './components/page-edit-screen/page-edit-screen.component';
import { PageEditScreenRoutingComponent } from './page-edit-screen-routing.component';

const routes: Routes = [
  {
    path: '',
    component: PageEditScreenRoutingComponent,
    children: [
      { path: '', component: PageEditScreenComponent, pathMatch: 'full' },
      {
        path: 'tray',
        loadChildren: () => import('../create-tray-screen/create-tray-screen.module').then((m) => m.CreateTrayScreenModule),
      },
      {
        path: 'edit',
        loadChildren: () => import('../create-tray-screen/edit-tray-screen.module').then((m) => m.EditTrayScreenModule),
      },
      {
        path: ':trayType/:trayId',
        loadChildren: () => import('../create-tray-screen/create-tray-screen.module').then((m) => m.CreateTrayScreenModule),
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PageEditScreenRoutingModule {}
